import { List, Map } from 'immutable';

import * as constants from './../constants';
import {
  AppStorageGroupRecord,
} from './../records';

const initialState = Map({
  groups: List(),
  loading: false,
  itemsPerPage: 100,
  currentPage: 1,
  moreItemsAvailable: false,
  nextPageUrl: null,
  prevPageUrl: null,
});

const appStorageGroupsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.APP_STORAGE_FETCH_GROUPS.REQUEST:
    case constants.APP_STORAGE_DELETE_APP_GROUP.REQUEST: {
      const updatedGroups = state.get('groups').filter((group) => group.id !== payload);
      return state.withMutations((mutable) => {
        mutable
          .set('groups', updatedGroups)
          .set('loading', true);
      });
    }
    case constants.APP_STORAGE_FETCH_GROUPS.SUCCESS: {
      const { items, links } = payload;

      const appStorageGroups = List(
        items.map((group) => new AppStorageGroupRecord(group)),
      );

      return state.withMutations((mutable) => {
        mutable
          .set('groups', appStorageGroups)
          .set('nextPageUrl', links.next)
          .set('prevPageUrl', links.prev)
          .set('moreItemsAvailable', !!links.next)
          .set('loading', false);
      });
    }
    case constants.APP_STORAGE_FETCH_GROUPS.FAILURE:
    case constants.APP_STORAGE_DELETE_APP_GROUP.SUCCESS:
    case constants.APP_STORAGE_DELETE_APP_GROUP.FAILURE:
      return state.set('loading', false);

    case constants.APP_STORAGE_DELETE_APP_VERSION.REQUEST: {
      let updatedGroups;
      const { group_id: groupId } = payload;
      const groups = state.get('groups');
      const affectedGroupIndex = groups.findIndex((group) => group.id === groupId);
      if (groups.get(affectedGroupIndex).count < 2) {
        // Delete the group when only 1 or less versions are associated with that group
        updatedGroups = groups.delete(affectedGroupIndex);
      } else {
        // Decrease the count for associated versions
        updatedGroups = groups.update(affectedGroupIndex, (oldGroup) => (
          new AppStorageGroupRecord({
            ...oldGroup,
            count: oldGroup.count - 1,
          })
        ));
      }
      return state.set('groups', updatedGroups);
    }

    default:
      return state;
  }
};

export default appStorageGroupsReducer;
export { initialState };
